import { useState } from 'react'
import { connect } from 'react-redux'

import { SET_VENDOR_LOGIN_STATE, LOGIN_ERROR } from '../../actions/actionTypes'
import { cleanVendorLoginAction } from '../../actions/userActions'
import { parseQueryString } from '../../libs/historyHelper'
import { VENDOR_LOGIN_STATES } from '../../reducers/uiReducer'
import {
  authenticatedSelector,
  VENDOR_LOGIN_PARAMS,
} from '../../reducers/userReducer'

function VendorLogin(props) {
  const { authenticated, cancelVendorLogin } = props

  // * prevent changing `authenticated` re-triggers handlerVendorLogin
  const [running, setRunning] = useState(false)

  if (running) return null

  const queryParams = parseQueryString()
  const params = {}
  for (const paramKey of VENDOR_LOGIN_PARAMS) {
    const param = queryParams[paramKey]
    if (param && param.length) {
      params[paramKey] = param
    } else {
      cancelVendorLogin(authenticated)
      return null
    }
  }

  props.handleVendorLogin({
    authenticated,
    params,
  })

  setRunning(true)

  return null
}

export default connect(
  state => ({
    authenticated: authenticatedSelector(state.user),
  }),
  dispatch => ({
    handleVendorLogin(payload) {
      dispatch(cleanVendorLoginAction(payload))
    },
    cancelVendorLogin(succeeded) {
      if (succeeded) {
        dispatch({
          type: SET_VENDOR_LOGIN_STATE,
          payload: VENDOR_LOGIN_STATES.SUCCEEDED,
        })
      } else {
        dispatch({ type: LOGIN_ERROR })
        dispatch({ type: SET_VENDOR_LOGIN_STATE })
      }
    },
  }),
)(VendorLogin)
